import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_ACTION_LIST_REQUEST = 'FETCH_ACTION_LIST_REQUEST';
export const FETCH_ACTION_LIST_SUCCESS = 'FETCH_ACTION_LIST_SUCCESS';
export const FETCH_ACTION_LIST_FAILURE = 'FETCH_ACTION_LIST_FAILURE';

export const FETCH_ACTION_REQUEST = 'FETCH_ACTION_REQUEST';
export const FETCH_ACTION_FAILURE = 'FETCH_ACTION_FAILURE';
export const FETCH_ACTION_SUCCESS = 'FETCH_ACTION_SUCCESS';

export const EDIT_ACTION_REQUEST = 'EDIT_ACTION_REQUEST';
export const EDIT_ACTION_FAILURE = 'EDIT_ACTION_FAILURE';
export const EDIT_ACTION_SUCCESS = 'EDIT_ACTION_SUCCESS';

export const CREATE_ACTION_REQUEST = 'CREATE_ACTION_REQUEST';
export const CREATE_ACTION_FAILURE = 'CREATE_ACTION_FAILURE';
export const CREATE_ACTION_SUCCESS = 'CREATE_ACTION_SUCCESS';

export const CLEAR_CURRENT_ACTION = 'CLEAR_CURRENT_ACTION';

const baseURL = 'agencies/config/actions';

export const fetchActionList = (type: ActionType[]) => ({
  [CALL_API]: {
    endpoint: `${baseURL}?type=${type}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_ACTION_LIST_REQUEST, FETCH_ACTION_LIST_SUCCESS, FETCH_ACTION_LIST_FAILURE],
  },
});

export const fetchAction = (actionId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${actionId}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_ACTION_REQUEST, FETCH_ACTION_SUCCESS, FETCH_ACTION_FAILURE],
  },
});

export const editAction = (actionId: number, actionRequest: IEditActionRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${actionId}`,
    method: 'put',
    body: actionRequest,
    authenticated: true,
    types: [EDIT_ACTION_REQUEST, EDIT_ACTION_SUCCESS, EDIT_ACTION_FAILURE],
  },
});

export const clearAction = () => ({
  type: CLEAR_CURRENT_ACTION,
});

export const createAction = (actionRequest: INotificationResponse) => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'post',
    body: actionRequest,
    authenticated: true,
    types: [CREATE_ACTION_REQUEST, CREATE_ACTION_SUCCESS, CREATE_ACTION_FAILURE],
  },
});
